import { Component }                from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { RadioGroupComponent } from '../radio-group/radio-group.component';

@Component({
  selector   : 'wor-tile-radio-group',
  styles: [ require('./tile-radio-group.component.scss') ],
  template: require('./tile-radio-group.component.html'),

  viewProviders: [
    {
      provide    : ControlContainer,
      useExisting: NgForm
    }
  ]
})
export class TileRadioGroupComponent extends RadioGroupComponent {
  defaultIconTheme = 'workshop';
}
